import {classes, style} from './thankyou-view-modal.st.css';
import React from 'react';
import {FlexLayout} from '@wix/devzai-common-client';
import {
    DoppeViewerLightboxModalPanel,
} from '../../../components/doppe-viewer-lightbox-modal-panel/doppe-viewer-lightbox-modal-panel';
import {DoppeViewerScrollView} from '../../../components/doppe-viewer-scroll-view/doppe-viewer-scroll-view';
import {
    DoppeViewerModalPanelSection,
} from '../../../components/doppe-viewer-modal-panel-section/doppe-viewer-modal-panel-section';
import {ThankYouView} from './thankyou-view';

export const DoppeActionThankYouModal = React.memo(function DoppeActionThankYouModal(
    props: ThankYouView.Props & {
        dismissButtonCallback: () => void;
    },
) {
    return (
        <DoppeViewerLightboxModalPanel
            className={style(classes.modal, FlexLayout.column.default)}
            dismissButtonCallback={props.dismissButtonCallback}
        >
            <DoppeViewerScrollView className={style(FlexLayout.fillRemainingVerticalSpace)}>
                <DoppeViewerModalPanelSection className={style(FlexLayout.column.default)}>
                    <div className={style(classes.thankyouContent, {})}>
                        <ThankYouView
                            onConfirm={props.onConfirm}
                            name={props.name}
                            price={props.price}
                            customThankYouMessage={props.customThankYouMessage}
                        />
                    </div>
                </DoppeViewerModalPanelSection>
            </DoppeViewerScrollView>
        </DoppeViewerLightboxModalPanel>
    );
});
